import _ from 'lodash'

const {
  vsServiceName: SelectPartQuantityModalServiceName,
} = require('../../../controls/selectPartQuantityModal')

repeaterController.$inject = ['$scope', SelectPartQuantityModalServiceName]
function repeaterController($scope, SelectPartQuantityModal) {
  $scope.formOptions = { formState: $scope.formState }
  $scope.add = add
  $scope.remove = remove
  $scope.copy = copy
  $scope.createLocalFields = createLocalFields

  if (!getModel()) {
    setModel([])
  }

  var fieldsBaseName = $scope.options.name || $scope.options.key

  var fieldsCopied = 0
  function createLocalFields(fields) {
    var newFields = _.cloneDeep(fields)
    addIds(newFields, fieldsBaseName, fieldsCopied++)
    return newFields
  }

  function remove(item) {
    const model = getModel()
    var index = model.indexOf(item)
    model.splice(index, 1)
  }

  function copy(item) {
    const model = getModel()
    var itemIndex = _.indexOf(model, item)
    if (itemIndex > -1) {
      var clone = _.clone(item, true)
      clone.Id = null
      delete clone.$$hashKey
      model.splice(itemIndex + 1, 0, clone)
    }
  }

  function add() {
    SelectPartQuantityModal.open({
      partQuantitySelected,
    })
  }

  function partQuantitySelected(partQuantity) {
    const currentModel = getModel() || []
    const existingPartQuantity = currentModel.find(
      (pq) => pq.PartPropertyId === partQuantity.PartPropertyId &&
        pq.Shelf === partQuantity.Shelf &&
        pq.Bin === partQuantity.Bin &&
        pq.PartId === partQuantity.PartId
    )
    if (existingPartQuantity) {
      return
    }

    currentModel.push({
      PartId: partQuantity.PartId,
      PartNumber: partQuantity.PartNumber,
      PartDescription: partQuantity.PartDescription,
      PartPropertyId: partQuantity.PartPropertyId,
      Shelf: partQuantity.Shelf,
      Bin: partQuantity.Bin,
      QuantityOnHand: partQuantity.Quantity,
      Quantity: 0,
    })
  }

  function addIds(fields, repeaterName, index) {
    _.forEach(fields, function (field) {
      if (field.fieldGroup) {
        addIds(field.fieldGroup, repeaterName, index)
        return // fieldGroups don't need an ID
      }

      if (field.templateOptions && field.templateOptions.fields) {
        addIds(field.templateOptions.fields, repeaterName, index)
      }
      var name = field.name || field.key
      field.id = field.name = repeaterName + '[' + index.toString() + '].' + name
    })
  }

  function getModel() {
    return $scope.model[$scope.options.key]
  }
  function setModel(value) {
    $scope.model[$scope.options.key] = value
  }

}

export default repeaterController